<div [ngClass]="appService.backGroundActive">

  <!--COOKIE-->
  <ng-container *ngIf="appService.visibleCookieBoolean">
    <app-cookie></app-cookie>
  </ng-container>

  <!--NORMAL-->
  <ng-container>
    <router-outlet></router-outlet>
  </ng-container>

</div>
